import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d6ae09ba&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d6ae09ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ae09ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6ae09ba')) {
      api.createRecord('d6ae09ba', component.options)
    } else {
      api.reload('d6ae09ba', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d6ae09ba&scoped=true&", function () {
      api.rerender('d6ae09ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zofdMTEFvB6r/JS/comp/DocBox.vue"
export default component.exports